import type { Team } from "@/mocks/events";

interface TeamBadgeProps {
  team: Team;
  size?: number;
}

export default function TeamBadge({ team, size = 48 }: TeamBadgeProps) {
  return (
    <div
      className="flex items-center justify-center rounded-xl font-heading font-bold text-background-50 ring-1 ring-background-50/10"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        backgroundColor: team.color,
        fontSize: `${Math.round(size * 0.3)}px`,
      }}
      aria-hidden="true"
    >
      {team.short}
    </div>
  );
}